import { bind } from 'bind-decorator';
import type { ObservableMap } from 'mobx';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import type { PropsWithChildren } from 'react';
import React from 'react';
import { Redirect } from 'react-router-dom';
import type { License } from 'tm3-core/api.dtos';

interface IProps extends PropsWithChildren {
  invert?: boolean;
  license?: ObservableMap<string, string>;
  mode?: 'all' | 'oneOf';
  needs: keyof License | Array<keyof License>;
  redirectToSorry?: boolean;
}

@inject('license')
@observer
class Licence extends React.Component<IProps> {
  static readonly defaultProps: Partial<IProps> = {
    invert: false,
    mode: 'all',
    needs: [],
    redirectToSorry: false
  };

  render() {
    if (!this.show) {
      return null;
    }

    const { isAllowed } = this;
    const { children, redirectToSorry } = this.props;

    if (isAllowed) {
      return children;
    } else if (redirectToSorry) {
      return <Redirect to="/sorry" />;
    } else {
      return null;
    }
  }

  @computed
  private get show(): boolean {
    let { license } = this.props;
    return license!.size > 0;
  }

  @computed
  private get isAllowed(): boolean {
    const { invert } = this.props;

    return this.meetsNeeds !== invert;
  }

  @computed
  private get meetsNeeds(): boolean {
    const { needs, mode } = this.props;
    if (!needs || needs.length === 0) {
      return true;
    } else if (!Array.isArray(needs)) {
      return this.meetsNeed(needs);
    } else if (mode === 'all') {
      return needs.every(this.meetsNeed);
    } else {
      return needs.some(this.meetsNeed);
    }
  }

  @bind
  private meetsNeed(key: string): boolean {
    const { license } = this.props;
    return !!license!.get(key);
  }
}

export default Licence;
